export default function PHP_next() {
  return (
    <div>
      <h1>PHP_next</h1>
    </div>
  );
}
